var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H2.25C1.3455 0 0 0.59925 0 2.25V12.75C0 14.4007 1.3455 15 2.25 15H13.5V13.5H2.259C1.9125 13.491 1.5 13.3545 1.5 12.75C1.5 12.6742 1.50675 12.6067 1.518 12.5452C1.602 12.1132 1.956 12.0075 2.259 12H13.5V1.5C13.5 1.10218 13.342 0.720644 13.0607 0.43934C12.7794 0.158035 12.3978 0 12 0ZM12 6.75L10.5 6L9 6.75V1.5H12V6.75Z",
    fill: "#62718A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc_icon.d9f8557a5c5a528a3c3267f0918cebf9.svg";
export { ForwardRef as ReactComponent };